/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
// eslint-disable-next-line no-unused-vars
import { PublicClientApplication } from '@azure/msal-browser';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Modal, Label,
} from 'reactstrap';

import * as url from '../../helpers/url_helper';
import { post } from '../../helpers/api_helper';

function AuthorizeModal(props) {
  const {
    shown,
    t,
    entity,
    onClose,
  } = props;

  const user = JSON.parse(localStorage.getItem('authUser'));

  const [modalOpen, setModalOpen] = useState(false);
  const [emailValue, setEmailValue] = useState(user.email);

  function generateCodeVerifier(length) {
    const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
    let verifier = '';

    for (let i = 0; i < length; i += 1) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      verifier += charset.charAt(randomIndex);
    }

    verifier = 'xqFkPgs6dykTYMRghb8K.gKkXNZ8pj9ael4ZLVAwGsl';
    return verifier;
  }

  useEffect(() => {
    setModalOpen(shown);
  }, [entity, shown]);

  // eslint-disable-next-line no-unused-vars
  const onSuccess = (x) => {
    setModalOpen(false);
    props.onSuccess(x);
  };

  const beginAuthorize = (authId, email, scopes, codeVerifier) => {
    const redir = encodeURIComponent('https://burnsville.shopjimmy.com/microsoft/authorize');

    const href = `https://login.microsoftonline.com/${entity.tenant_id}/oauth2/v2.0/authorize`
      + `?state=--${authId}--&client_id=${entity.client_id}&response_type=code&redirect_uri=`
      + `${redir}&code_challenge=${codeVerifier}&code_challenge_method=plain`
      + `&scope=${scopes.join(' ')}&login_hint=${email}`;

    window.location.href = href;

    return false;
  };

  const createAuth = async (e) => {
    try {
      e.preventDefault();

      const scopes = [];
      for (let i = 0; i < e.target.scope.length; i += 1) {
        if (e.target.scope[i].checked === true) scopes.push(e.target.scope[i].value);
      }

      const currentDate = new Date();
      const futureDate = new Date(currentDate);
      futureDate.setDate(currentDate.getDate() + 500);

      const obj = {
        scope: scopes.join(', '),
        app_id: entity.id,
        email: e.target.email.value,
        expires_at: futureDate.toISOString().replace(/([0-9]{4}-[0-9]{2}-[0-9]{2})T([0-9]{2}:[0-9]{2}:[0-9]{2}).+/, '$1 $2'),
        code_verifier: generateCodeVerifier(43),
      };

      const { id } = await post(url.POST_MICROSOFT_AUTHORIZATION, obj);

      beginAuthorize(id, obj.email, scopes, obj.code_verifier);
    } catch (error) {
      // console.log(error);
    }
  };

  const jsx = (
    <Modal
      size="md"
      isOpen={modalOpen}
    >
      <div className="modal-header">
        <h5
          className="modal-title mt-0"
        >
          {t('New Authorization')}
        </h5>
        <button
          onClick={() => { setModalOpen(false); onClose(); }}
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <form id="AuthorizeForm" onSubmit={createAuth}>
          <div className="mt-3 mb-3">
            <Label for="modal_email">{t('Remote Account Email')}</Label>
            <input type="email" name="email" value={emailValue} onChange={(e) => setEmailValue(e.target.value)} className="form-control" required />
          </div>

          <h5 className="mb-3">{t('Scopes')}</h5>
          <div className="form-check form-check-success mb-3 mt-3">
            <input
              className="form-check-input"
              type="checkbox"
              value="https://graph.microsoft.com/User.Read.All"
              id="scope0"
              name="scope"
              checked
              readOnly
            />
            <Label
              className="form-check-label"
              for="scope0"
            >
              https://graph.microsoft.com/User.Read.All
            </Label>
          </div>
          <div className="form-check form-check-success mb-3 mt-3">
            <input
              className="form-check-input"
              type="checkbox"
              value="https://graph.microsoft.com/Mail.Read"
              id="scope1"
              name="scope"
            />
            <Label
              className="form-check-label"
              for="scope1"
            >
              https://graph.microsoft.com/Mail.Read
            </Label>
          </div>
          <div className="form-check form-check-success mb-3 mt-3">
            <input
              className="form-check-input"
              type="checkbox"
              value="https://graph.microsoft.com/Mail.ReadWrite"
              id="scope2"
              name="scope"
            />
            <Label
              className="form-check-label"
              for="scope2"
            >
              https://graph.microsoft.com/Mail.ReadWrite
            </Label>
          </div>
          <div className="form-check form-check-success mb-3">
            <input
              className="form-check-input"
              type="checkbox"
              value="https://outlook.office.com/SMTP.Send"
              id="scope3"
              name="scope"
            />
            <Label
              className="form-check-label"
              for="scope3"
            >
              https://outlook.office.com/SMTP.Send
            </Label>
          </div>
        </form>
      </div>
      <div className="modal-footer">
        <button
          type="button"
          onClick={() => { setModalOpen(false); onClose(); }}
          className="btn btn-soft-dark"
          data-dismiss="modal"
        >
          {t('Cancel')}
        </button>
        <button
          type="submit"
          form="AuthorizeForm"
          className="btn btn-primary"
        >
          {t('Authorize')}
        </button>
      </div>
    </Modal>
  );

  return jsx;
}

AuthorizeModal.defaultProps = {
  shown: false,
  entity: {},
  onSuccess: () => { },
  onClose: () => { },
};

AuthorizeModal.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  entity: PropTypes.object,
  shown: PropTypes.bool,
  onSuccess: PropTypes.func,
  onClose: PropTypes.func,
};

export default connect(() => ({

}), {})(withTranslation()(AuthorizeModal));
